import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { auth } from "../../../utils/auth";
import Loader from "../../general/Loader";
import { request } from "../../../utils/request";
import dayjs from "dayjs";
import { money } from "../../../utils/helpers";

const Print = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [movimiento, setMovimiento] = useState();

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const getMovimiento = async () => {
        setLoading(true);

        const res = await request("movimientos/" + id);
        setMovimiento(res.data);

        setLoading(false);
    };

     useEffect(() => {
        getMovimiento();
    }, []);

    // Espera a que loading pase a false, con los datos ya reflejados en el
    // DOM, antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (!loading) {
            window.print();
        }
    }, [loading]);

    return <>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">Reporte Movimiento Masivo Inventario</h2>
            <div className="col-md-12 text-center">
                {sucursal.nombre} - {sucursal.direccion} •{" "}
                {dayjs().format("DD/MM/YYYY")}
            </div>
        </div>

        {loading 
            ? <Loader />
            : <>
            <div className="row mt-3">
                <div className="col-4"><strong>Codigo:</strong> <span>{movimiento.codigo}</span></div>
                <div className="col-4"><strong>Titulo:</strong> <span>{movimiento.titulo}</span></div>
                <div className="col-4"><strong>Fecha:</strong> <span>{dayjs(movimiento.fecha).format('YYYY-MM-DD')}</span></div>
            </div>

            <div className="row">
                <div className="col-4"><strong>Realizado por:</strong> <span>{movimiento.usuario.nombre} {movimiento.usuario.apellido}</span></div>
                <div className="col-4"><strong>Estado:</strong> <span>{movimiento.estado.toUpperCase()}</span></div>
                <div className="col-4">{movimiento.estado === 'cerrado' && <><strong>Cerrado a:</strong> <span>{dayjs(movimiento.closed_at).format('YYYY-MM-DD hh:mm a')}</span></>}</div>
            </div>

            <table className='table print-productos my-4'>
                <thead className="head-table-producto">
                    <th>Producto</th>
                    <th>En Inventario</th>
                    <th>Tipo de Ajuste</th>
                    <th>Cant</th>
                    <th>Motivo</th>
                    <th>Nueva Existencia</th>
                    <th>Valor</th>
                </thead>

                <tbody>
                    {movimiento.productos.map((row) => {
                        const delta = row.operacion === 'incrementar' ? row.cantidad : -row.cantidad;
                        const existencia = movimiento.estado === 'cerrado' ? row.existencia_actual - delta : row.existencia_actual;
                        return <tr key={row.id}>
                            <td>{row.producto.referencia} - {row.producto.nombre}</td>
                            <td>{existencia}</td>
                            <td>{row.operacion.toUpperCase()}</td>
                            <td>{row.cantidad}</td>
                            <td style={{textWrap: 'wrap'}}>{row.descripcion}</td>
                            <td>{existencia + delta}</td>
                            <td>{money(row.valor)}</td>
                        </tr>
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={6} className="text-right"><strong>Total</strong></td>
                        <td><strong>{money(movimiento.valor_total)}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </>}
    </>
};

export default Print;